import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Whale(props: PresetArtProps) {
  return (
    <PresetFrame background="#1d4ed8" {...props}>
      <path d="M9 37 Q9 24 29 24 Q47 24 49 35 L56 28 V45 L50 41 Q45 51 28 51 Q9 51 9 37 Z" fill="#ffffff" />
      <circle cx="20" cy="36" r="2.5" fill="#1f2937" />
      <path
        d="M27 20 V13 M27 15 L22 11 M27 15 L32 11"
        fill="none"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </PresetFrame>
  );
}
